import { render, staticRenderFns } from "./NFTViewDetail.vue?vue&type=template&id=92d05504&scoped=true&"
import script from "./NFTViewDetail.vue?vue&type=script&lang=ts&"
export * from "./NFTViewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./NFTViewDetail.vue?vue&type=style&index=0&id=92d05504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d05504",
  null
  
)

export default component.exports